<template>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <add-order></add-order>
    <div class="ibox row">
      <div class="ibox-title">
        <h5>Orders</h5>
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-order" v-if="user.admin">Add</button>
      </div>
      <div class="ibox-content col-lg-12">
        <filters></filters>
        <div class="col-lg-12 m-t-sm"></div>
        <list></list>
      </div>
    </div>
  </div>
</template>
<script>
import Filters from './Orders/Filters'
import List from './Orders/List'
import axios from 'axios'
import { mapGetters } from 'vuex'
import AddOrderModal from './Orders/AddOrderModal'

export default {
  components: {
    filters: Filters,
    list: List,
    addOrder: AddOrderModal
  },
  mounted () {
    document.title = 'Orders :: PBN360 by Aphex Media'
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      user: 'getUser'
    })
  },
  methods: {
    search () {
      axios.get('/pbn/orders')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Orders.vue